import { useRole } from "@/contexts/RoleContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { UserCircle2, ChevronDown } from "lucide-react";

export function RoleSwitcher() {
  const { role, roles, changeRole } = useRole() || {};
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-medium"
          style={{ color: "var(--oim-text-secondary)", border: "1px solid var(--oim-border)" }}
          data-testid="role-switcher-trigger"
        >
          <UserCircle2 className="w-4 h-4" />
          <span className="hidden md:inline">{role}</span>
          <ChevronDown className="w-3 h-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[var(--oim-surface)] border-[var(--oim-border)] text-[var(--oim-text)]">
        {roles?.map((r) => (
          <DropdownMenuItem key={r} onClick={() => changeRole(r)} data-testid={`role-option-${r.replace(/[^a-zA-Z]/g, "-")}`}>
            {r}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
